import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom'; // Importing useNavigate from react-router-dom
const RegisteredClientsTable = () => {
    const [clients, setClients] = useState([]);
    const [jobCountsByCompany, setJobCountsByCompany] = useState([]);
    const [jobCountsNoCompany, setJobCountsNoCompany] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const navigate = useNavigate(); // Initialize navigate function
    const [stagedClient, setStagedClient] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            const token = sessionStorage.getItem("Transport Admin AuthToken");
            try {
                const [clientsResponse, byCompanyResponse, noCompanyResponse] = await Promise.all([
                    axios.get('https://zoomautos.co.uk/api/Signup'
                        ,{ params: { _t: new Date().getTime() } // Add timestamp to bypass cache
      }
                    ), // API for registered clients
                    axios.get('https://zoomautos.co.uk/api/Subcontract/job-count/by-company'
                        , {
                            headers: {
                              Authorization: `Bearer ${token}`, // Include token in headers
                            },
                            params: {
                              _t: new Date().getTime(), // Add timestamp to bypass cache
                            },
                          }), // API for job counts by company
                    axios.get('https://zoomautos.co.uk/api/Subcontract/job-count/no-company'
                        , {
                            headers: {
                              Authorization: `Bearer ${token}`, // Include token in headers
                            },
                            params: {
                              _t: new Date().getTime(), // Add timestamp to bypass cache
                            },
                          }),
                ]);

                setClients(clientsResponse.data);
                
                setJobCountsByCompany(byCompanyResponse.data);
                console.log(byCompanyResponse.data)
                setJobCountsNoCompany(noCompanyResponse.data);
                console.log(noCompanyResponse.data)
                setLoading(false);
            } catch (err) {
                console.error('Error fetching data:', err);
                setError('Failed to fetch data');
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }
    const handleRowClick = (client) => {
        navigate(`/Logistics/AdminPortal/Customers/${client._id||client.contactNumber}`, { state: { client } });
    };
    
    

    return (
        <div className='overalls'>
            <img
                                      src="/Summary.png"
                                      alt="Logistics Background"
                                      className="background-image2"
                                    />
                  
        <div style={{ padding: '20px', overflowX: 'auto', marginTop: '80px' }}>
            <h1 style={{color:'white'}}>Registered Clients with Job Counts</h1>
            <table >
                <thead>
                    <tr>
                        <th>Username</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Contact Number</th>
                        <th>Company Name</th>
                        <th>Address</th>
                        <th>Post Code</th>
                        <th>City</th>
                        <th>Job Count</th>
                    </tr>
                </thead>
                <tbody>
                    {clients.map((client, index) => {
                        let jobCount = 0;
                        
                        if (client.companyName) {
                            // If client has a company, look for job count by company
                            const jobCountByCompany = jobCountsByCompany.find(
                                (job) => job._id === client.Id
                                
                            );
                            jobCount = jobCountByCompany ? jobCountByCompany.count : 0;
                        } 

                        return (
                            <tr 
  key={index} 
  onClick={() => handleRowClick(client)} 
  style={{ cursor: 'pointer' }}
>
  <td>{client.username ?? 'N/A'}</td>
  <td>{client.name ?? 'N/A'}</td>
  <td>{client.email ?? 'N/A'}</td>
  <td>{client.contactNumber ?? 'N/A'}</td>
  <td>{client.companyName ?? 'N/A'}</td>
  <td>{client.Address ?? 'N/A'}</td>
  <td>{client.PostCode ?? 'N/A'}</td>
  <td>{client.city ?? 'N/A'}</td>
  <td>{jobCount ?? 0}</td>
</tr>

                        );
                    })}
                    {jobCountsNoCompany.map((client, index) => {

                        return (
                            <tr 
    key={index} 
    onClick={() => handleRowClick({
        name: client._id || 'N/A',
        email: client.email || 'N/A',
        contactNumber: client.contact || 'N/A',
    
        Address: client.customeraddress || 'N/A',
    
    })} 
    style={{ cursor: 'pointer' }}
>
    <td>{client.username || 'N/A'}</td>
    <td>{client._id || 'N/A'}(Individual)</td>
    <td>{client.email || 'N/A'}</td>
    <td>{client.contactNumber || 'N/A'}</td>
    <td>{client.companyName || 'N/A'}</td>
    <td>{client.Address || 'N/A'}</td>
    <td>{client.PostCode || 'N/A'}</td>
    <td>{client.city || 'N/A'}</td>
    <td>{client.count}</td>
</tr>

                        );
                    })}
                </tbody>
            </table>
            </div>
        </div>
    );
};

export default RegisteredClientsTable;
